export { ListFormPage as ListFormOpnamePage } from './list_form';
export { ListItemFaskerPage } from './list_item_fasker';
export { DetailItemPage as DetailItemFaskerPage} from './detail_item';
export { FormItemPage as FormItemFaskerPage } from './form_item';



// WEBPACK FOOTER //
// ./src/pages/opname/index.ts